/* eslint-disable react/prop-types */

import React from 'react';
import { Form } from 'react-bootstrap';

export default function CommonWidgetOptions({ state, onChange }) {
  // const [test, setTest] = useState('');
  // console.log('PROPS.STATE===', props.state);
  // if (!props.state.test) {
  //   props.state.test = '';
  // }

  return (
    <>
      {/* <Form.Check 
            type='checkbox'
            id='defaultCheckbox'
            label='Show Header'
            checked={state.showHeader}
            onChange={e => {
                onChange(Object.assign({}, state, { showHeader: e.target.checked }))
            }}    
        /> */}
        
        <Form.Check 
            type='checkbox'
            id='defaultCheckbox'
            label='Show Background Image'
            checked={state.showBackgroundImage}
            onChange={e => {
                onChange(Object.assign({}, state, { showBackgroundImage: e.target.checked }))
            }}    
        />
    </>
  );
}
